const path = 'assets/img/clientes/';

export const clientes = [
    {
        name: 'Bro',
        src: `${path}bro_logo.jpg`
    },
    {
        name: 'Coral',
        src: `${path}coral.jpg`
    },
    {
        name: 'junta Freguesia do Montijo',
        src: `${path}junta.jpg`
    }
    ,
    {
        name: 'Krypton',
        src: `${path}krypton.jpg`
    }
    ,
    {
        name: 'EPC - Empresa Portuguesa de Cenários',
        src: `${path}epc.jpg`
    }
    ,
    {
        name: 'Câmara Municipal de Alcochete',
        src: `${path}alcochete.jpg`
    },
    {
        name: 'Câmara Municipal de Montijo',
        src: `${path}montijo.jpg`
    },
    {
        name: 'Plural',
        src: `${path}plural.jpg`
    },
    {
        name: 'Santa Casa da Misericórdia do Montijo',
        src: `${path}misericordia.jpg`
    },
    {
        name: 'Shine Iberia',
        src: `${path}shine.jpg`
    },
    {
        name: 'SP Televisão',
        src: `${path}sp.jpg`
    },
    {
        name: 'Twenty Four',
        src: `${path}twentyfour.jpg`
    },
    {
        name: 'Vivi Film',
        src: `${path}vivi.jpg`
    }

]